import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  variant?: 'default' | 'light';
  size?: 'sm' | 'md' | 'lg';
}

/**
 * SaveDelete Logo - Creative Typography
 *
 * Concept: "Save" + "Delete" with strikethrough on Delete
 * Represents saving content before it's deleted
 */
const Logo: React.FC<LogoProps> = ({ variant = 'default', size = 'md' }) => {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  const colorClasses = {
    default: {
      save: 'text-slate-900',
      delete: 'text-slate-400',
      line: 'bg-slate-400'
    },
    light: {
      save: 'text-white',
      delete: 'text-slate-400',
      line: 'bg-slate-400'
    }
  };

  const colors = colorClasses[variant];

  return (
    <Link to="/" className={`font-bold tracking-tight ${sizeClasses[size]} hover:opacity-80 transition-opacity`}>
      <span className={colors.save}>Save</span>
      <span className={`relative ${colors.delete}`}>
        Delete
        <span
          className={`absolute left-0 right-0 top-1/2 h-[2px] ${colors.line}`}
          style={{ transform: 'rotate(-5deg)' }}
        />
      </span>
    </Link>
  );
};

export default Logo;
